"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataYandex = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var utils_1 = require("@dp-instant/utils");
var social_1 = require("@dp-instant/social");
var UserDataYandex = (function (_super) {
    tslib_1.__extends(UserDataYandex, _super);
    function UserDataYandex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserDataYandex.prototype.init = function (player) {
        this._player = player;
        this.read();
    };
    UserDataYandex.prototype.write = function (keys, flush) {
        if (flush === void 0) { flush = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        obj = {};
                        this.cache.forEach(function (v, k) {
                            if (!keys || keys.includes(k)) {
                                obj[k] = v;
                            }
                        });
                        utils_1.log.trace(this, "write", obj);
                        if (!(this._player && this._player.setData)) return [3, 2];
                        return [4, this._player.setData(obj, flush)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        utils_1.log.warn("CookieDataBase::write. Not supported");
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    UserDataYandex.prototype.read = function (keys) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rawData_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this._player && this._player.getData)) return [3, 2];
                        return [4, this._player.getData(keys)];
                    case 1:
                        rawData_1 = _a.sent();
                        utils_1.log.trace(this, "read", rawData_1);
                        if (rawData_1) {
                            Object.keys(rawData_1).forEach(function (i) {
                                _this.cache.set(i, rawData_1[i]);
                            });
                        }
                        this.lastSync = Date.now();
                        return [3, 3];
                    case 2:
                        utils_1.log.warn("CookieDataBase::read. Not supported");
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    UserDataYandex = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], UserDataYandex);
    return UserDataYandex;
}(social_1.UserDataBase));
exports.UserDataYandex = UserDataYandex;
//# sourceMappingURL=UserDataYandex.js.map